export function getFromStore(key, fallback) {
  try {
    return JSON.parse(window.localStorage.getItem(key)) || fallback;
  } catch (e) {
    return fallback;
  }
}

export function setToStore(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
}
